const autocompleteModalDocEmployee = {
  documentTypes: 'Tipo del Documento',
  document: 'Documento'
};

export default autocompleteModalDocEmployee;
